import { Config } from './config'
// Different configs for different companies.
import { andwinConfig } from './sites/andwin/config'
import { azerConfig } from './sites/azer/config'
import { bsiConfig } from './sites/bsi/config'
import { blueridgeConfig } from './sites/blueridge/config'
import { cleanroomConfig } from './sites/cleanroom/config'
import { daiConfig } from './sites/dai/config'
import { daiggerConfig } from './sites/daigger/config'
import { defineConfig } from './sites/define/config'
import { dsiConfig } from './sites/dsi/config'
import { ecomConfig } from './sites/ecom/config'
import { farnellConfig } from './sites/farnell/config'
import { fisherConfig } from './sites/fisher/config'
import { geneseeConfig } from './sites/genesee/config'
import { gmiConfig } from './sites/gmi/config'
import { h2iConfig } from './sites/h2i/config'
import { herrConfig } from './sites/herr/config'
import { kewauneeConfig } from './sites/kewaunee/config'
import { kloeppelConfig } from './sites/kloeppel/config'
import { labtechConfig } from './sites/labtech/config'
import { labdepotConfig } from './sites/labdepot/config'
import { labrepcoConfig } from './sites/labrepco/config'
import { lbiConfig } from './sites/lbi/config'
import { locConfig } from './sites/loc/config'
import { lpsConfig } from './sites/lps/config'
import { mglabsolutionsConfig } from './sites/mglabsolutions/config'
import { midlandConfig } from './sites/midland/config'
import { nelsonConfig } from './sites/nelson/config'
import { netaConfig } from './sites/neta/config'
import { novaConfig } from './sites/nova/config'
import { nowakConfig } from './sites/nowak/config'
import { nurnbergConfig } from './sites/nurnberg/config'
import { nycomConfig } from './sites/nycom/config'
import { officeplannersConfig } from './sites/officeplanners/config'
import { onepointeConfig } from './sites/onepointe/config'
import { prolineConfig } from './sites/proline/config'
import { qalineConfig } from './sites/qaline/config'
import { sciConfig } from './sites/sci/config'
import { scottConfig } from './sites/scott/config'
import { spectrumConfig } from './sites/spectrum/config'
import { spectrumrxConfig } from './sites/spectrumrx/config'
import { srsConfig } from './sites/srs/config'
import { stellarConfig } from './sites/stellar/config'
import { superiorConfig } from './sites/superior/config'
import { taylorConfig } from './sites/taylor/config'
import { thermalConfig } from './sites/thermal/config'
import { thomasConfig } from './sites/thomas/config'
import { weberConfig } from './sites/weber/config'
import { gssConfig } from './sites/gss/config'
import { omnilabConfig } from './sites/omnilab/config'
import { technimarkConfig } from './sites/technimark/config'
import { testConfig } from './sites/test/config'
import { phillConfig } from './sites/phillocraft/config'
import { biologixConfig } from './sites/biologix/config'
import { labproConfig } from './sites/labpro/config'
import { emeraldConfig } from './sites/emerald/config'
import { aresConfig } from './sites/ares/config'
import { medsupplyConfig } from './sites/medsupply/config'
import { labbuildConfig } from './sites/labbuild/config'
import { iciConfig } from './sites/ici/config'
import { scilogexConfig } from './sites/scilogex/config'
import { csiConfig } from './sites/csi/config'
import { krackelerConfig } from './sites/krackeler/config'
import { symbioteConfig } from './sites/symbiote/config'
import { airmasterConfig } from './sites/airmaster/config'


// Also add the config to the config table.
export const configTable: Map<string, Config> = new Map(Object.entries({
  andwin: andwinConfig,
  azer: azerConfig,
  bsi: bsiConfig,
  blueridge: blueridgeConfig,
  biologix: biologixConfig,
  cleanroom: cleanroomConfig,
  dai: daiConfig,
  daigger: daiggerConfig,
  define: defineConfig,
  dsi: dsiConfig,
  ecom: ecomConfig,
  farnell: farnellConfig,
  fisher: fisherConfig,
  genesee: geneseeConfig,
  gmi: gmiConfig,
  gss: gssConfig,
  h2i: h2iConfig,
  herr: herrConfig,
  kewuanee: kewauneeConfig,
  kloeppel: kloeppelConfig,
  labtech: labtechConfig,
  labdepot: labdepotConfig,
  labrepco: labrepcoConfig,
  labpro: labproConfig,
  lbi: lbiConfig,
  loc: locConfig,
  lps: lpsConfig,
  mglabsolutions: mglabsolutionsConfig,
  midland: midlandConfig,
  nelson: nelsonConfig,
  neta: netaConfig,
  nova: novaConfig,
  nowak: nowakConfig,
  nurnberg: nurnbergConfig,
  nycom: nycomConfig,
  officeplanners: officeplannersConfig,
  onepointe: onepointeConfig,
  omnilab: omnilabConfig,
  proline: prolineConfig,
  qaline: qalineConfig,
  scott: scottConfig,
  spectrum: spectrumConfig,
  spectrumrx: spectrumrxConfig,
  srs: srsConfig,
  sci: sciConfig,
  stellar: stellarConfig,
  superior: superiorConfig,
  taylor: taylorConfig,
  technimark: technimarkConfig,
  test: testConfig,
  thermal: thermalConfig,
  thomas: thomasConfig,
  weber: weberConfig,
  phillocraft: phillConfig,
  emerald: emeraldConfig,
  ares: aresConfig,
  medsupply: medsupplyConfig,
  labbuild: labbuildConfig,
  ici: iciConfig,
  scilogex: scilogexConfig,
  csi: csiConfig,
  krackeler: krackelerConfig,
  symbiote: symbioteConfig,
  airmaster: airmasterConfig,
}))